import { useCallback, useState } from 'react';

export interface UseSidebarCollapsedResult {
  /** Сайдбар свёрнут (десктоп). */
  collapsed: boolean;
  toggle: () => void;
}

/**
 * Свёрнутый сайдбар раздела: состояние + память между заходами.
 *
 * Свёрнутый сайдбар отдаёт место контенту — широким таблицам его не хватает. Работает в паре:
 * `UniversalSidebar collapsed` прячет постоянную колонку, `MainContent fullWidth` растягивает
 * контент. Мобильная шторка не затрагивается: ниже 870px сайдбара и так нет, там бургер.
 *
 * `storageKey` — свой у каждого раздела (`adminSidebarCollapsed`, `appSidebarCollapsed`,
 * `qaSidebarCollapsed`, `wikiSidebarCollapsed`): админку сворачивают под таблицы, кабинет — нет.
 * Разбор — docs/admin-pages.md §4.
 */
export function useSidebarCollapsed(storageKey: string): UseSidebarCollapsedResult {
  const [collapsed, setCollapsed] = useState(() => {
    try {
      return localStorage.getItem(storageKey) === '1';
    } catch {
      return false;
    }
  });

  const toggle = useCallback(() => {
    setCollapsed((prev) => {
      const next = !prev;
      try {
        localStorage.setItem(storageKey, next ? '1' : '0');
      } catch {
        // Хранилище недоступно — просто не запомним между заходами
      }
      return next;
    });
  }, [storageKey]);

  return { collapsed, toggle };
}

export default useSidebarCollapsed;
